import * as z from "zod";

export const getProductSources = {
  name: "getProductSources" as const,
  input: z.object({ search: z.string().optional() }),
  output: z.object({ sources: z.array(z.string()) }),
};
